export interface FolderInterface {
  id: string;
  name: string;
  boschNT: string;
  sortOrder: number;
  folderType: FolderType
  referenceID: number | null;
}

export enum FolderType {
  FOLDER = "FOLDER",
  COLLECTION = "COLLECTION",
}
